//IMPORTING COLORS
import {
  WHITE,
  TEXT_COLOR,
  PRIMARY_BTN_FK,
  SECONDARY_BTN_FK,
  TITLE_COLOR_FK,
  ICON_COLOR_FK,
  FADE_BG_FK,
  FOOTER_BG_FK,
  LIGHT_BG_FK,
} from "../../utils/colors";

//IMPORTING FONTS
import {
  TITLE_SIZE,
  SUB_TITLE_SIZE,
  TEXT_SIZE,
  SUB_TEXT_SIZE,
} from "../../utils/fonts";

//IMPORT NUMBERS
import { WHATS_FLORICULTURA_FK_LINK } from "../../utils/phoneNumbers";

import { useEffect } from "react";
import DynamicTitle from "../../components/DynamicTitle";
import BannerAbout from "../../components/BannerAbout";
import ServicesCards from "../../components/ServicesCards";
import ServicesImg2 from "../../assets/images/funeraria-servico-1.jpg";
import ServicesImg3 from "../../assets/images/funeraria-servico-2.jpg";
import ServicesImg4 from "../../assets/images/funeraria-servico-3.JPG";
import ServicesImg5 from "../../assets/images/funeraria-servico-4.jpg";
import ServicesImg6 from "../../assets/images/funeraria-servico-5.jpg";
import ServicesImg7 from "../../assets/images/funeraria-servico-6.jpg";
import FKFlowers from "../../assets/images/fk-flores.jpg";
import LogoFuneraria from "../../assets/logo/logo-FK.png";
import BannerSection from "../../components/BannerSection";
import JoinUsCall from "../../components/JoinUsCall";
import LocationCall from "../../components/LocationCall";
import FooterBar from "../../components/FooterBar";
import Obituary from "../../components/Obituary";
import VirtualCandleCall from "../../components/VirtualCandleCall";
import FlowersCall from "../../components/FlowersCall";
import { PiFlowerTulip } from "react-icons/pi";
import { LuCircleCheckBig } from "react-icons/lu";
import VirtualTour from "../../components/VirtualTour";
import RecentPosts from "../../components/RecentPostsCall";
import FunerariBG from "../../assets/images/fk-bg.jpg";
import FunerariBGMob from "../../assets/images/fk-bg-mob.jpg";
import "./Funeraria.css";

function Funeraria() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const funerariaCards = [
    {
      id: 1,
      title: (
        <h3 style={{ color: TITLE_COLOR_FK, fontSize: TEXT_SIZE }}>
          ESTRUTURA COMPLETA PARA DESPEDIDA
        </h3>
      ),
      image: ServicesImg2,
      icon1: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_FK }}
          className="services-icon-card"
        />
      ),
      item1: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Equipe especializada
        </p>
      ),
      icon2: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_FK }}
          className="services-icon-card"
        />
      ),
      item2: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Acolhimento e atendimento de excelência
        </p>
      ),
      icon3: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_FK }}
          className="services-icon-card"
        />
      ),
      item3: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Estrutura própria e completa
        </p>
      ),
      icon4: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_FK }}
          className="services-icon-card"
        />
      ),
      item4: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Vagas de estacionamento
        </p>
      ),
      icon5: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_FK }}
          className="services-icon-card"
        />
      ),
      item5: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Assistência 24 horas
        </p>
      ),
    },
    {
      id: 2,
      title: (
        <h3 style={{ color: TITLE_COLOR_FK, fontSize: TEXT_SIZE }}>
          SALAS DE VELÓRIO EXCLUSIVAS
        </h3>
      ),
      image: ServicesImg3,
      icon1: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_FK }}
          className="services-icon-card"
        />
      ),
      item1: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Salas privativas e confortáveis
        </p>
      ),
      icon2: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_FK }}
          className="services-icon-card"
        />
      ),
      item2: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Ar-condicionado
        </p>
      ),
      icon3: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_FK }}
          className="services-icon-card"
        />
      ),
      item3: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Sala privada para a família
        </p>
      ),
      icon4: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_FK }}
          className="services-icon-card"
        />
      ),
      item4: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>Frigobar</p>
      ),
      icon5: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_FK }}
          className="services-icon-card"
        />
      ),
      item5: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Especialista em homenagens que honram histórias de vida
        </p>
      ),
    },
    {
      id: 3,
      title: (
        <h3 style={{ color: TITLE_COLOR_FK, fontSize: TEXT_SIZE }}>
          SALA CERIMONIAL DE CREMAÇÃO
        </h3>
      ),
      image: ServicesImg4,
      icon1: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_FK }}
          className="services-icon-card"
        />
      ),
      item1: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Serviço de cremação em sala especial
        </p>
      ),
      icon2: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_FK }}
          className="services-icon-card"
        />
      ),
      item2: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Ambiente automatizado e climatizado
        </p>
      ),
      icon3: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_FK }}
          className="services-icon-card"
        />
      ),
      item3: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Cerimônia exclusiva
        </p>
      ),
      icon4: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_FK }}
          className="services-icon-card"
        />
      ),
      item4: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Excelente escolha para despedidas que honrem histórias de vida
        </p>
      ),
    },
    {
      id: 4,
      title: (
        <h3 style={{ color: TITLE_COLOR_FK, fontSize: TEXT_SIZE }}>
          CERIMONIAL PERSONALIZADO
        </h3>
      ),
      image: ServicesImg5,
      icon1: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_FK }}
          className="services-icon-card"
        />
      ),
      item1: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Conduzido por Cerimonialistas Profissionais
        </p>
      ),
      icon2: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_FK }}
          className="services-icon-card"
        />
      ),
      item2: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Detalhes que honram especificamente a história da pessoa
        </p>
      ),
      icon3: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_FK }}
          className="services-icon-card"
        />
      ),
      item3: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Homenagem particular
        </p>
      ),
      icon4: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_FK }}
          className="services-icon-card"
        />
      ),
      item4: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Despedida única
        </p>
      ),
    },
    {
      id: 5,
      title: (
        <h3 style={{ color: TITLE_COLOR_FK, fontSize: TEXT_SIZE }}>
          FLORICULTURA E <br />
          CAFETERIA
        </h3>
      ),
      image: ServicesImg6,
      icon1: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_FK }}
          className="services-icon-card"
        />
      ),
      item1: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Cafeteria 24h
        </p>
      ),
      icon2: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_FK }}
          className="services-icon-card"
        />
      ),
      item2: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Espaço self-service
        </p>
      ),
      icon3: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_FK }}
          className="services-icon-card"
        />
      ),
      item3: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Serviço completo de floricultura
        </p>
      ),
      icon4: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_FK }}
          className="services-icon-card"
        />
      ),
      item4: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Flores e coroas personalizadas
        </p>
      ),
    },
    {
      id: 6,
      title: (
        <h3 style={{ color: TITLE_COLOR_FK, fontSize: TEXT_SIZE }}>
          FUNERAL A DISTANCIA
        </h3>
      ),
      image: ServicesImg7,
      icon1: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_FK }}
          className="services-icon-card"
        />
      ),
      item1: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Despedida acompanhada virtualmente
        </p>
      ),
      icon2: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_FK }}
          className="services-icon-card"
        />
      ),
      item2: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Ambiente virtual privado e seguro
        </p>
      ),
      icon3: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_FK }}
          className="services-icon-card"
        />
      ),
      item3: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Facilidade de acesso através da internet
        </p>
      ),
      icon4: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_FK }}
          className="services-icon-card"
        />
      ),
      item4: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Mesmo distante, próximo
        </p>
      ),
    },
  ];

  return (
    <div className="Funeraria">
      <DynamicTitle
        pageTitle="Grupo Krause - Funerária Krause"
        pageMeta="Funerária Krause"
        pageContent="São mais de 100 anos oferecendo apoio às famílias região do Vale dos Sinos nos momentos mais difíceis, quando as pessoas mais precisam de atenção e apoio."
      />
      <BannerSection
        white={WHITE}
        fadeBG={FADE_BG_FK}
        iconTitle={
          <PiFlowerTulip
            style={{ color: WHITE }}
            className="banner-section-icon"
          />
        }
        bannerTitle={"SERVIÇOS FUNERÁRIOS"}
        bannerTitleSize={TITLE_SIZE}
        bannerSubTitle={"Funerária Krause. Honrando histórias de vida."}
        bannerSubTitleSize={SUB_TITLE_SIZE}
        bannerBG={FunerariBG}
        bannerBGmobile={FunerariBGMob}
      />
      <BannerAbout
        companyBrand={LogoFuneraria}
        firstText={`Se há uma palavra que representa a Funerária Krause, essa palavra
              é tradição. São mais de 100 anos oferecendo apoio às famílias de
              Novo Hamburgo e região nos momentos mais difíceis, quando as
              pessoas mais precisam de atenção e apoio.`}
        secondText={`Mais do que garantir que tudo saia corretamente na despedida do
              seu ente querido, a Funerária Krause entende a dor desse momento,
              e faz de tudo para amenizá-lo. Com atenção, respeito e, acima
              de tudo, entendendo que todos deixam saudades. Afinal, somos todos
              feitos de histórias.`}
        textColor={TEXT_COLOR}
        textSize={TEXT_SIZE}
      />
      <ServicesCards
        white={WHITE}
        titleColor={TITLE_COLOR_FK}
        iconColor={ICON_COLOR_FK}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        cards={funerariaCards}
        cardSize={500}
        textTop={184}
        textMinHeight={326}
      />
      <Obituary
        white={WHITE}
        iconColor={ICON_COLOR_FK}
        titleColor={TITLE_COLOR_FK}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        subTitleSize={SUB_TITLE_SIZE}
        subTextSize={SUB_TEXT_SIZE}
        secondaryBtnColor={SECONDARY_BTN_FK}
        primaryBtnColor={PRIMARY_BTN_FK}
        funeralDistanciaCall={true}
      />
      <VirtualCandleCall
        white={WHITE}
        iconColor={ICON_COLOR_FK}
        titleColor={TITLE_COLOR_FK}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        primaryBtnColor={PRIMARY_BTN_FK}
      />
      <FlowersCall
        white={WHITE}
        iconColor={ICON_COLOR_FK}
        titleColor={TITLE_COLOR_FK}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        primaryBtnColor={PRIMARY_BTN_FK}
        whatsAppFloricultura={WHATS_FLORICULTURA_FK_LINK}
        flowerImage={FKFlowers}
      />
      <VirtualTour
        iconColor={ICON_COLOR_FK}
        titleColor={TITLE_COLOR_FK}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        subTextContent="Pensar em cada detalhe para garantir uma despedida única e memorável é fundamental aqui na Funerária Krause."
        mapFrame={
          <iframe
            src="https://www.google.com/maps/embed?pb=!4v1759521222440!6m8!1m7!1sSy3ORim9z85_az0xX89ACQ!2m2!1d-29.67890056604569!2d-51.11765295612145!3f28.28!4f-16.709999999999994!5f0.4000000000000002"
            width="900"
            height="500"
            style={{ border: 0 }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Virtual Tour Funerária Krause"
          />
        }
      />
      <RecentPosts
        white={WHITE}
        iconColor={ICON_COLOR_FK}
        titleColor={TITLE_COLOR_FK}
        textColor={TEXT_COLOR}
        btnColor={ICON_COLOR_FK}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        subTitleSize={SUB_TITLE_SIZE}
        subTextSize={SUB_TEXT_SIZE}
      />
      <LocationCall
        white={WHITE}
        iconColor={ICON_COLOR_FK}
        titleColor={TITLE_COLOR_FK}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        fadeBG={FADE_BG_FK}
      />
      <JoinUsCall
        white={WHITE}
        iconColor={ICON_COLOR_FK}
        titleColor={TITLE_COLOR_FK}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        fadeBG={FADE_BG_FK}
        circleBG={LIGHT_BG_FK}
        btnColor={PRIMARY_BTN_FK}
      />
      <FooterBar titleColor={TITLE_COLOR_FK} footerBarBG={FOOTER_BG_FK} />
    </div>
  );
}

export default Funeraria;
